/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {checkToken, signin} from '../../../../api/modules/auth'
import swal from 'sweetalert'
import {useDispatch} from 'react-redux'
import {setAccesses} from '../../../../_metronic/redux/content'
import {useTranslation, initReactI18next} from 'react-i18next'
import {KTSVG} from '../../../../_metronic/helpers'
import {url} from 'inspector'
import {setToken} from '../../../../_metronic/redux/content'
import {useAppDispatch} from '../../../../redux/hooks'
import {setAuthUser, setCredential} from '../../../../redux/slices/authSlices'
import {Spinner} from 'react-bootstrap'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: 'admin@demo.com',
  password: 'demo',
}

export function Login() {
  const dispath = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('*test')
  const [error, setError] = useState(0)
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useAppDispatch()

  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const {t} = useTranslation()
  const navigate = useNavigate()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('role-flagg')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('cus-grupp')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
    localStorage.removeItem('sector_ids')
    localStorage.removeItem('role-flag')
  }

  const login = async (e: any) => {
    e.preventDefault()
    try {
      if (email != '' && password != '') {
        removeStorage()
        setLoading(true)
        var resp = await signin({
          nama_pengguna: email,
          password: password,
        })
        dispatch(setAuthUser(resp.data))
        localStorage.setItem('role-flag', resp.data.credential.role_flag)
        localStorage.setItem('user_code', resp.data.credential.username)
        localStorage.setItem('role_flagg', resp.data.credential.role_flag)
        localStorage.setItem('sector_ids', resp.data.credential.sector_ids)
        localStorage.setItem('email', resp.data.credential.email)
        // localStorage.setItem('name', resp.data.credential.name)
        if (resp.data.credential.role_flag == null)
          localStorage.setItem(
            'username',
            resp.data.credential.customer?.title != null
              ? resp.data.credential.customer?.title + ' ' + resp.data.credential.customer?.name
              : resp.data.credential.customer?.name
          )
        else localStorage.setItem('username', resp.data.credential.name)
        localStorage.setItem('user-id', resp.data.credential.user_id)
        localStorage.setItem('cust-code', resp.data.credential.customer_code)
        localStorage.setItem('cus-grup', resp.data.credential.customer_account_group)
        localStorage.setItem('cus-grupp', resp.data.credential.customer_account_group)
        localStorage.setItem('cust-group', resp.data.credential.customer_account_group)
        localStorage.setItem('user-segment', resp.data.credential.segments)
        localStorage.setItem('user-product-type', resp.data.credential.product_types)

        if (!resp.data.error) {
          localStorage.setItem('token', resp.data.access_token)
          checkToken(resp.data.access_token).then((res) => {
            dispatch(setCredential(res.data.credential))
            try{
              const test = atob(resp.data.credential)
              const temp = JSON.parse(test)
              localStorage.setItem('credential', test)
              localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
              localStorage.setItem('credential-decoded', test)
            }catch(e){}
          })
          if (!resp.data.accesses) {
            // console.log('ga punya')
          } else {
            localStorage.setItem('access', JSON.stringify(resp.data.accesses.role_accesses))
            localStorage.setItem('accesses', JSON.stringify(resp.data.accesses))
            // dispath(setAccesses(JSON.stringify(resp.data.accesses.role_accesses)))
          }
          dispath(setToken(resp.data.access_token))
          navigate('/dashboard')
          setLoading(false)
        } else alert(resp.data.message)
      } else
        swal({
          title: t('isiEmailPassword'),
          icon: 'error',
        })
    } catch (e: any) {
      setLoading(false)
      if (e?.response?.data?.code == 400) {
        swal({
          title: t(e?.response?.data?.message),
          icon: 'error',
        })
      } else {
        swal({
          title: t('connection error'),
          icon: 'error',
        })
      }
    }
  }

  useEffect(() => {
    localStorage.setItem('kt_theme_mode_menu', 'light')
    localStorage.setItem('kt_theme_mode_value', 'light')
    dispath(setToken(''))
  }, [])

  return (
    <>
      <div id='auth'>
        <div className='test'>
          <img className='image' src={toAbsoluteUrl(`/media/login-page.png`)} />
          <div className='text'>
            <img className='me-5' src={toAbsoluteUrl(`/media/danantara-black.png`)} />
            <img src={toAbsoluteUrl(`/media/pi.svg`)} />
          </div>
        </div>
        {/* <div className='imagesAuth'>
          <img src={toAbsoluteUrl(`/media/login-page.png`)} />
          <div className="text">
            test
          </div>
        </div> */}
        <div className='sectionFormAuth'>
          <img src={toAbsoluteUrl(`/media/andalan-logo.svg`)} style={{marginLeft: '-1rem'}} />
          <h1 className='fw-normal mb-3 mt-1'>Login</h1>
          <h2 className='fw-normal mb-8'>Selamat Datang!</h2>
          <form onSubmit={login} className='formAuth'>
            <label className='form-label mb-1 fs-4 fw-normal'>Username</label>
            <div className='form-group has-search mb-3'>
              <span className='fa fa-user form-control-feedback'></span>
              <input
                type='text'
                className='form-control'
                placeholder='Username'
                onChange={(e: any) => setEmail(e.target.value)}
              />
            </div>

            <label className='form-label mb-1 fs-4 fw-normal'>Password</label>
            <div className='form-group has-search'>
              <span className='fa fa-lock form-control-feedback'></span>
              <div className='input-group'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className='form-control'
                  placeholder='Password'
                  onChange={(e: any) => setPassword(e.target.value)}
                />
                <div className='input-group-append'>
                  <button type='button' onClick={() => setShowPassword(!showPassword)} className='btn btn-secondary' style={{
                    borderRadius: '0 30px 30px 0'
                  }}>
                    <i className={'fa ' + (!showPassword ? 'fa-eye' : 'fa-eye-slash')}></i>
                  </button>
                </div>
              </div>
            </div>
            <div className='mb-4 mt-3 d-flex justify-content-end'>
              <Link
                to='/auth/forgot-password'
                className='forgotPassword'
                style={{color: '#274070'}}
              >
                {t('Forgot your password')}?
              </Link>
            </div>
            <div className='actionUser d-flex justify-content-center flex-column align-items-center mt-8'>
              <button className='btn w-100' style={{backgroundColor: '#274070'}}>
                {loading ? (
                  <>
                    <Spinner animation='border' variant='light' size='sm' />
                  </>
                ) : (
                  <>
                    <p className='py-1 text-white'>Log In</p>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* <div id="auth">
        <div className="imagesAuth">
          <img src={toAbsoluteUrl(`/media/login-page.png`)} />
        </div>
        <div className="sectionFormAuth">
          <div className="headAuth">
            <h1>Log In</h1>
          </div>
          <form onSubmit={login} className="formAuth">
            <div className='fv-row mb-10'>
              <label className='form-label fs-6 fw-bolder text-dark'>Username</label>
              <input
                placeholder='Username'
                className={clsx('form-control form-control-lg form-control-solid')}
                type='text'
                name='email'
                autoComplete='off'
                onChange={(e: any) => setEmail(e.target.value)}
              />
            </div>

            <div className='fv-row'>
              <div className='d-flex justify-content-between mt-n5'>
                <div className='d-flex flex-stack mb-2'>

                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>

                </div>
              </div>
              <input
                placeholder='Password'
                type='password'
                autoComplete='off'
                className={clsx('form-control form-control-lg form-control-solid')}
                onChange={(e: any) => setPassword(e.target.value)}
              />
            </div>
            <div className="mb-4 mt-2 d-flex justify-content-end">
              <Link to='/auth/forgot-password' className="forgotPassword text-primary">{t("Forgot your password")}?</Link>
            </div>
            <div className="actionUser d-flex justify-content-center flex-column align-items-center mt-8">
              <button className="btn btn-primary w-100"><p className='py-1'>Log In</p></button>
            </div>
          </form>
        </div>
      </div> */}
    </>
    // <div className='form w-100'>
    //   <form onSubmit={login}>
    //     <div className='fv-row mb-10'>
    //       <label className='form-label fs-6 fw-bolder text-dark'>Username</label>
    //       <input
    //         placeholder='Username'
    //         className={clsx('form-control form-control-lg form-control-solid')}
    //         type='text'
    //         name='email'
    //         autoComplete='off'
    //         onChange={(e: any) => setEmail(e.target.value)}
    //       />
    //     </div>
    //     {/* end::Form group */}

    //     {/* begin::Form group */}
    //     <div className='fv-row'>
    //       <div className='d-flex justify-content-between mt-n5'>
    //         <div className='d-flex flex-stack mb-2'>
    //           {/* begin::Label */}
    //           <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
    //           {/* end::Label */}
    //         </div>
    //       </div>
    //       <input
    //         placeholder='Password'
    //         type='password'
    //         autoComplete='off'
    //         className={clsx('form-control form-control-lg form-control-solid')}
    //         onChange={(e: any) => setPassword(e.target.value)}
    //       />
    //     </div>
    //     {/* end::Form group */}

    //     <div className='d-flex justify-content-end mt-2 mb-6'>
    //       <Link
    //         to='/auth/forgot-password'
    //         className='link-primary fs-6 fw-bolder'
    //         style={{marginLeft: '5px'}}
    //       >
    //         Forgot Password ?
    //       </Link>
    //     </div>

    //     {/* begin::Action */}
    //     <div className='text-center mt-2'>
    //       <button
    //         type='submit'
    //         id='kt_sign_in_submit'
    //         className='btn btn-lg btn-primary w-100 mb-5'
    //       >
    //         <span className='indicator-label'>Continue</span>
    //       </button>
    //     </div>
    //   </form>
    // </div>
  )
}
